// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FBhhL","signatureBlock":"Footer_signatureBlock__3QURE","signature":"Footer_signature__ymH6w"};